<h2 class="text-xl font-bold mb-4">Inhalte verständlich</h2>

<div class="mb-6">
  <h3 class="text-lg font-semibold text-green-600 flex items-center mb-2">
    <span class="mr-2">✅</span> Akzeptieren, wenn:
  </h3>
  <ul class="list-disc ml-6 space-y-2">
    <li>Der Inhalt klar und verständlich formuliert ist.</li>
    <li>
      Keine unnötigen Fachbegriffe oder komplizierte Sprache verwendet werden.
    </li>
    <li>Die Kernbotschaft ohne Missverständnisse erfasst werden kann.</li>
  </ul>
</div>

<div class="mb-6">
  <h3 class="text-lg font-semibold text-red-600 flex items-center mb-2">
    <span class="mr-2">❌</span> Ablehnen bzw. Änderung erforderlich, wenn:
  </h3>
  <ul class="list-disc ml-6 space-y-2">
    <li>Der Inhalt missverständlich, unklar oder widersprüchlich ist.</li>
    <li>
      Der Text sprachliche oder grammatikalische Fehler enthält, die das
      Verständnis erschweren.
    </li>
    <li>
      Wichtiges Hintergrundwissen fehlt, um den Inhalt vollständig zu verstehen.
    </li>
  </ul>
</div>

<div class="mt-4 p-4 bg-blue-50 rounded-lg">
  <p class="flex items-center text-blue-800">
    <span class="mr-2">➡</span>
    <span class="font-semibold">Best Practice:</span>
    Falls der Inhalt unverständlich ist, sollte eine detaillierte Begründung
    eingegeben werden, damit der Antragsteller gezielt nachbessern kann.
  </p>
</div>
